/* globals sage */

import Modals from '../blocks/modals.js'

export default function Contact7 () {
  var currentURL = window.location.href
  if (currentURL.includes('mon-compte')) {
    $('.wpcf7-form').submit(function (event) {
      // Prevent the default form submission
      event.preventDefault()
      $('.button-submitted-contact').prop('disabled', true).addClass('submit-contact-in-process')
      $('.button-submitted-contact').closest('.submit-btn').addClass('disabled')
      $('.button-submitted-contact').val('En cours')
    })

     document.addEventListener('wpcf7invalid', function(event) {
      $('.button-submitted-contact').removeAttr('disabled').removeClass('submit-contact-in-process')
      $('.button-submitted-contact').closest('.submit-btn').removeClass('disabled')
      $('.button-submitted-contact').val('Sauvegarder')
     }, false);


    $.ajax({
      method: 'POST',
      url: sage.ajax_url,
      data: { action: 'get_user_info' }
    })

      .done(result => {
        const commissions = (result.data.data.properties && result.data.data.properties.commission) ? result.data.data.properties.commission.split(';') : []
        const regionHubspot = result.data.options.region
        const fonctionsHubspot = result.data.options.fonctions
        const servicesHubspot = result.data.options.services
        const abonnementHubspot = result.data.options.abonnement
        const commissionHubspot = result.data.options.commission
        if (result.data.data.properties && result.data.data.properties.commission) {
          const value = 'Je souhaite m\'inscrire aux commissions et faire partie de la liste de diffusion'
          $('input[name="accept-commission[]"]').prop('checked', true)
          $('div[data-id="group-commission"]').css('display', 'block').removeClass('wpcf7cf-hidden')
        } else {
          $('div[data-id="group-commission"]').css('display', 'none')
        }

        const newsletters = result.data.data.properties.subscription_type ? result.data.data.properties.subscription_type.split(';') : []

        if (result.data.data.properties.subscription_type) {
          const value = 'Je souhaite recevoir les actualités et infos de la profession'
          $('input[name="accept-newsletter[]"]').prop('checked', true)
          $('div[data-id="group-newsletters"]').css('display', 'block').removeClass('wpcf7cf-hidden')
        } else {
          $('div[data-id="group-newsletters"]').css('display', 'none')
        }
        const fonctions = result.data.data.properties.fonctions ? result.data.data.properties.fonctions.split(/[,;]/).filter(item => item !== '') : []
        const services = result.data.data.properties.service ? result.data.data.properties.service.split(/[,;]/).filter(item => item !== '') : []
        const regions = result.data.data.properties.region ? result.data.data.properties.region.split(/[,;]/).filter(item => item !== '') : []
        $('input[name=\'lastname\']').val(result.data.data.properties.lastname)
        $('input[name=\'email\']').val(result.data.data.properties.email).css('background-color','#ECF6F7')
        $('input[name=\'jobtitle\']').val(result.data.data.properties.jobtitle)
        $('input[name=\'firstname\']').val(result.data.data.properties.firstname)
        $('input[name=\'phone\']').val(result.data.data.properties.phone)

        /* charger les options fonctions */
        $.each(fonctionsHubspot, function (index, option) {
          $('select[name="fonctions[]"]').append($('<option>', {
            value: option.value,
            text: option.label
          })).attr('disabled', true)
        })
        $('select[name="fonctions[]"] option').each(function () {
          if (fonctions.includes($(this).val())) {
            $(this).attr('selected', true)
          } else {
            $(this).removeAttr('selected')
          }
        })

        /* charger les champs service */
        $.each(servicesHubspot, function (index, option) {
          $('select[name="service[]"]').append($('<option>', {
            value: option.value,
            text: option.label,
            selected: services.includes(option.value)
          }))
        })

        // $('select[name="service[]"] option').each(function () {
        //   if (services.includes($(this).val())) {
        //     $(this).attr('selected', true)
        //   } else {
        //     $(this).removeAttr('selected')
        //   }
        // })

        /* charger les champs Regions */
        $.each(regionHubspot, function (index, option) {
          $('select[name="region[]"]').append($('<option>', {
            value: option.value,
            text: option.label,
            selected: regions.includes(option.value)
          }))
        })

        /* charger les options commission */

        $.each(commissionHubspot, function (index, checkbox) {
          const checkboxElement = $('<input>', {
            type: 'checkbox',
            value: checkbox.value,
            id: 'checkbox-commission' + index,
            name: 'commission[]'
          })

          const labelElement = $('<label>', {
            text: checkbox.label,
            for: 'checkbox-commission' + index
          })

          const spanElement = $('<span>', {
            class: 'wpcf7-list-item-label'
          })

          const labeWrapper = labelElement.append(checkboxElement).append(spanElement)

          $('#commissionContainer').append(labeWrapper)
        })

        $.each(commissions, function (i, value) {
          $('input[name="commission[]"][value="' + value + '"]').prop('checked', true)
        })

        /* charger les options abonnement */
        $.each(abonnementHubspot, function (index, checkbox) {
          const checkboxElement = $('<input>', {
            type: 'checkbox',
            value: checkbox.value,
            id: 'checkbox-subscription' + index,
            name: 'subscription_type[]'
          })

          const labelElement = $('<label>', {
            text: checkbox.label,
            for: 'checkbox-subscription' + index
          })

          const spanElement = $('<span>', {
            class: 'wpcf7-list-item-label'
          })

          const labeWrapper = labelElement.append(checkboxElement).append(spanElement)

          $('#abonnementContainer').append(labeWrapper)
        })

        $.each(newsletters, function (i, value) {
          $('input[name="subscription_type[]"][value="' + value + '"]').prop('checked', true)
        })

        if (result.data.data.properties.role_contact === 'Niveau Basic') {
          $('label:contains(\'Flash Juridique\')').parent().find('input[type="checkbox"]').remove()
          $('label:contains(\'Flash Juridique\')').remove()
        }
      })

    document.addEventListener('wpcf7mailsent', function (event) {
      const modal = new Modals()
      modal.openModal('contact7')
    }, false)


      $(document).ready(function(){


          $('form.wpcf7-form input[type=submit].wpcf7-submit').on('click', function(event){
              let $form = $(this).closest('form.wpcf7-form');


              $(':input',$form).each(function(){
                  let $this = $(this);
                  switch(true){
                      case $this.is(':checked'):
                          $this.prop("defaultChecked", true);
                          break;
                      case $this.is('select'):
                          let values = $this.val();
                          if(!$.isArray(values)) values = [values];
                          $('option', $this).each(function(){
                              let $option = $(this);
                              $option[0].defaultSelected= false;
                              if(values.indexOf($option.val()) >= 0){
                                  $option[0].defaultSelected=true;
                              }
                          });
                          break;
                      default:
                          $this.prop("defaultValue", $this.val());
                          break;
                  }
              }); //input each

          }); //submit click

      });//document ready
  }
}
